<template>
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12554_92754)">
      <g clip-path="url(#clip1_12554_92754)">
        <path d="M19 0H0V12H19V0Z" fill="#005BBB"/>
        <path d="M19 6H0V12H19V6Z" fill="#FFD500"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12554_92754">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
      <clipPath id="clip1_12554_92754">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'FlagUA',
}
</script>
